const s3Config = {
  bucketName: 'sellha-fulfillment-xml',
  dirName: 'images',
  region: 'ap-northeast-2',
  accessKeyId: 'AKIAVN7FDPVXJQQFYA6T',
  secretAccessKey: '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',
};

export default s3Config;
